import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './field.scss';

export default class Field extends Component {
  render() {
    return (
        <span className="field">
            <h3 className="field-name">{this.props.title}</h3>
            <p className="field-value">{this.props.value}</p>
        </span>
    );
  }
}

Field.propTypes = {
    title: PropTypes.string,
    value: PropTypes.string,
}

Field.defaultProps = {
    title: '',
    value: '',
}



// WEBPACK FOOTER //
// ./src/shared/components/Field.js